const encodeQueryParams = params => {
    const query = Object.keys(params)
        .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
        .join('&');

    return query === '' ? query : `?${query}`;
};

export default encodeQueryParams;